import React from 'react'
import { Box } from '@alto-avios/alto-ui'
import { getContentAlignment, Alignment } from '@reward-platform/contentful'
import styles from './SearchPageSectionContainer.module.scss'

type Props = {
  inline?: boolean
  children?: React.ReactNode
}

const ContentContainer = ({
  children,
  alignment,
}: React.PropsWithChildren<{ alignment?: Alignment }>) => {
  return (
    <Box className={styles.content} alignItems={getContentAlignment(alignment)}>
      {children}
    </Box>
  )
}

const CardContainer = ({ children }: React.PropsWithChildren) => {
  return (
    <Box className={styles.cardRow} role="list">
      {React.Children.map(children, (child) => (
        <Box className={styles.card} role="listitem">
          {child}
        </Box>
      ))}
    </Box>
  )
}

const SearchPageSection = ({ inline, children }: Props) => {
  return <Box className={inline ? styles.inlineContainer : styles.blockContainer}>{children}</Box>
}

SearchPageSection.ContentContainer = ContentContainer
SearchPageSection.CardContainer = CardContainer

export default SearchPageSection
